// extracted by mini-css-extract-plugin
module.exports = {"icon":"style_icon__7B9Bw","tab":"style_tab__uU_lP","font":"style_font__x4Sl8"};